import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import logo from '../assets/img/1.png';

function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Show navbar at top of page
      if (currentScrollY < 10) {
        setIsVisible(true);
      }
      // Hide when scrolling down, show when scrolling up
      else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false);
        setIsMobileMenuOpen(false); // Close mobile menu when hiding
      } else if (currentScrollY < lastScrollY) {
        setIsVisible(true);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className={`fixed top-0 left-0 w-full px-6 py-4 z-50 transition-transform duration-300 ease-in-out ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
      <div className="flex justify-between items-center max-w-7xl mx-auto bg-black/20 rounded-full px-6 py-2 backdrop-blur-sm border border-white/10">
        {/* Logo */}
        <div className="flex items-center space-x-3">
          <img 
            src={logo} 
            alt="StarGate Logo" 
            className="h-10 w-auto transition-transform duration-300 hover:scale-105"
          />
          <span className="text-2xl font-display font-bold text-white">
            STARGATE
          </span>
        </div>

        {/* Desktop Navigation Menu */}
        <div className="hidden md:flex items-center space-x-6 bg-black/20 rounded-full px-4 py-2 backdrop-blur-sm border border-white/20">
          <button 
            onClick={() => scrollToSection('home')}
            className="text-white hover:text-red transition-all duration-300 font-medium text-sm relative group px-3 py-1 rounded-full hover:bg-white/10"
          >
            Home
            <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 h-0.5 bg-red transition-all duration-300 w-0 group-hover:w-6"></span>
          </button>
          
          <button 
            onClick={() => scrollToSection('services')}
            className="text-white hover:text-red transition-all duration-300 font-medium text-sm relative group px-3 py-1 rounded-full hover:bg-white/10"
          >
            Services
            <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 h-0.5 bg-red transition-all duration-300 w-0 group-hover:w-6"></span>
          </button>
          
          <button 
            onClick={() => scrollToSection('about')}
            className="text-white hover:text-red transition-all duration-300 font-medium text-sm relative group px-3 py-1 rounded-full hover:bg-white/10"
          >
            About
            <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 h-0.5 bg-red transition-all duration-300 w-0 group-hover:w-6"></span>
          </button>
          
          <button 
            onClick={() => scrollToSection('process')}
            className="text-white hover:text-red transition-all duration-300 font-medium text-sm relative group px-3 py-1 rounded-full hover:bg-white/10"
          >
            Process
            <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 h-0.5 bg-red transition-all duration-300 w-0 group-hover:w-6"></span>
          </button>
          
          
          
          <button 
            onClick={() => scrollToSection('team')}
            className="text-white hover:text-red transition-all duration-300 font-medium text-sm relative group px-3 py-1 rounded-full hover:bg-white/10"
          >
            Team
            <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 h-0.5 bg-red transition-all duration-300 w-0 group-hover:w-6"></span>
          </button>
          
          <button 
            onClick={() => scrollToSection('contact')}
            className="text-white hover:text-red transition-all duration-300 font-medium text-sm relative group px-3 py-1 rounded-full hover:bg-white/10"
          >
            Contact
            <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 h-0.5 bg-red transition-all duration-300 w-0 group-hover:w-6"></span>
          </button>

          <button 
            onClick={() => scrollToSection('gallery')}
            className="text-white hover:text-red transition-all duration-300 font-medium text-sm relative group px-3 py-1 rounded-full hover:bg-white/10"
          >
            Gallery
            <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 h-0.5 bg-red transition-all duration-300 w-0 group-hover:w-6"></span>
          </button>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button 
            onClick={toggleMobileMenu}
            className="text-white p-2 rounded-full hover:bg-white/20 transition-colors duration-300 focus:outline-none backdrop-blur-sm border border-white/20"
          >
            {isMobileMenuOpen ? (
              <X className="w-5 h-5" />
            ) : (
              <Menu className="w-5 h-5" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-6 right-6 mt-2 bg-black/20 backdrop-blur-lg border border-white/20 rounded-2xl shadow-2xl">
          <div className="px-6 py-4 space-y-2">
            <button 
              onClick={() => scrollToSection('home')}
              className="block text-white hover:text-red hover:bg-white/10 transition-colors duration-300 font-medium py-3 px-4 rounded-xl w-full text-left"
            >
              Home
            </button>
            
            <button 
              onClick={() => scrollToSection('services')}
              className="block text-white hover:text-red hover:bg-white/10 transition-colors duration-300 font-medium py-3 px-4 rounded-xl w-full text-left"
            >
              Services
            </button>
            
            <button 
              onClick={() => scrollToSection('about')}
              className="block text-white hover:text-red hover:bg-white/10 transition-colors duration-300 font-medium py-3 px-4 rounded-xl w-full text-left"
            >
              About
            </button>
            
            <button 
              onClick={() => scrollToSection('process')}
              className="block text-white hover:text-red hover:bg-white/10 transition-colors duration-300 font-medium py-3 px-4 rounded-xl w-full text-left"
            >
              Process
            </button>
            
            <button 
              onClick={() => scrollToSection('gallery')}
              className="block text-white hover:text-red hover:bg-white/10 transition-colors duration-300 font-medium py-3 px-4 rounded-xl w-full text-left"
            >
              Gallery
            </button>
            
            <button 
              onClick={() => scrollToSection('team')}
              className="block text-white hover:text-red hover:bg-white/10 transition-colors duration-300 font-medium py-3 px-4 rounded-xl w-full text-left"
            >
              Team
            </button>
            
            <button 
              onClick={() => scrollToSection('contact')}
              className="block text-white hover:text-red hover:bg-white/10 transition-colors duration-300 font-medium py-3 px-4 rounded-xl w-full text-left"
            >
              Contact
            </button>
            
            <button
              onClick={() => scrollToSection('contact')}
              className="btn-primary w-full py-3 rounded-xl font-semibold"
            >
              Get Quote
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Header;